/**
 * Replaces placeholder spans rendered by the TinyMCE editor
 * (`<span data-placeholder="varName|label" ...>label</span>`) back to the
 * canonical `{varName|label}` / `{varName}` token syntax used throughout the app.
 *
 * Used when reading content out of the editor (onBlur, onDrop, onPaste) so the
 * caller always receives the normalized form regardless of how TinyMCE rendered
 * the content internally.
 */
export const normalizeEditorContent = (html: string): string => {
	if (!html) {
		return html;
	}

	return html.replace(
		/<span[^>]*data-placeholder="([^"]+)"[^>]*>[\s\S]*?<\/span>/g,
		(_match: string, varName: string) => `{${varName}}`
	);
};
